module.exports = __webpack_public_path__ + "static/media/ANII.95bc3642.jpg";